import React from 'react'
import { withTranslation } from 'react-i18next';

function Signup({className, t, i18n}){

  return(
    <div className="component-Signup nopadding text-center buttons">
      <div className={"component-Signup__wrapper"}>
        <a href={`https://app.duuers.com/api/v1/auth/google?lng=${i18n.language}`} className="btn size60 white semibold uppercase radius6 component-Signup__google">
          <div className={"component-Signup__google__section"}>
            <img src="/images/google-logo.png" alt=""/>
          </div>
          <span>{t('menu.googleSignUp')}</span>
        </a>
        <div className={"component-Signup__separator"}>
          <span className="component-Signup__separator__line"></span>
          <span className={`component-Signup__separator__letter`}>{t('component.signup.or')}</span>
          <span className={"component-Signup__separator__line"}></span>
        </div>
        <div className={"component-Signup__normal"}>
          <a href={`https://app.duuers.com/auth/signup?lng=${i18n.language}`} className="btn size60 padding_sides35 radius6 semibold uppercase">{t('component.signup.signup')}</a>
        </div>
      </div>
    </div>


  )
}

export default withTranslation()(Signup);
